import EmptyState from "@casino/client/components/EmptyState";
import getTournamentColor from "@casino/legacy/client/features/Tournaments/shared/TournamentCard/utils/getTournamentColor";
import Trophy from "@casino/legacy/client/features/Tournaments/shared/Trophy";
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import capitalize from "@casino/legacy/shared/utils/string/capitalize";
import { TypographyText } from "@workspace/frontend-ui";
import Container from "./Container";

type Props = {
  status?: TournamentStatus;
  onlyMine?: boolean;
};

const getNoTournamentText = (activityType?: TournamentStatus) => {
  switch (activityType) {
    case "current":
      return "tournaments.no-active-tournaments";
    case "future":
      return "tournaments.no-future-tournaments";
    case "past":
      return "tournaments.no-past-tournaments";
    default:
      return "general.empty_state_my_participations";
  }
};

const TournamentEmptyState: FC<Props> = ({ status = "current", onlyMine }) => {
  const title = useTranslation(
    status
      ? `gameleaderboard.${status}`
      : "general.menu_item.my_participations",
  );
  const tournamentColor = getTournamentColor({ status });

  return (
    <Container>
      <TypographyText variant="large" as="span">
        {capitalize(title.toLowerCase())}
      </TypographyText>
      <EmptyState
        icon={
          <Trophy
            className={`bg-secondary rounded-full`}
            size="sm"
            style={{ color: tournamentColor }}
          />
        }
        title={
          <span>
            {useTranslation(
              onlyMine
                ? "general.empty_state_my_participations"
                : getNoTournamentText(status),
            )}
          </span>
        }
      />
    </Container>
  );
};

export default TournamentEmptyState;
